import modalModule from './modal';
import closeAlertMessage from './alert-message';

const ComponentsModule = () => {
  modalModule();
  closeAlertMessage();
};

export default ComponentsModule;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/components/components.js